import config from './configuration'
import ConstantsList from '../common/Constants';
import { saveAs } from 'file-saver';
import moment from 'moment-timezone';

// this block needed to get the login Token and Login user _id 
let localData = localStorage.getItem('userData');
let userData={}
if(localData){
    userData = JSON.parse(localData);
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/* Service Function starts here */
// get info from the configuration.js file
async function getConfig() {
    return config;
}

//POST - Get User Login Details using _id
async function getLoginUserData() { // This method calling from Redux
    let api_url= config.BASE_URL + 'api/getUserDetailsById';
    let param = {"userId" : userData.data.userId}
    return callPOST(api_url, param);
}

// Non-2xx API responses can contain business-validation details that the
// calling screen must display (for example, HTTP 409 conflict messages).
// Do not create an unhandled rejected promise before the response body is read.
function handleResponseError(response) {
    console.warn("API response status:", response.status);
    return response;
}

// API Error Handling
async function handleError(error) {
    console.log(error.message);
}

// Common GET Method 
async function callGET(api_url) {
    return fetch(api_url,{
                method:'GET',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ userData.token
                }
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                if(items.statusCode === 401){
                    console.log(">> Session Timeout", items);
                    localStorage.removeItem("token");
                    localStorage.removeItem("userData");                    
                    window.location.href = ConstantsList.LOGIN;
                    alert(items.message || "Session expired. Please login again.");
                    return;
                }else{
                    return items;
                }           
            }).catch(error => {
                console.log(">> e", error);
                handleError(error);
            });
}

// Common POST Method
async function callPOST(api_url,param) {
    // console.log(">> check URL", api_url);
    if(!param){
        param = {}
    }
    param.timeZone = userTimezone;
    param.userDateTime = moment.tz(userTimezone).toDate();
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json",
                    "Authorization": 'Bearer '+ userData.token
                },
                body:JSON.stringify(param)
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                      
                if(param.download) {
                    
                // Extract filename from header
                 const filename = response.headers.get('content-disposition')
                 .split(';')
                 .find(n => n.includes('filename='))
                 .replace('filename=', '')
                 .trim();
                    
                 response.blob().then((respo)=>{
                    saveAs(respo, filename);
                 });
                } 
                // Download the file

                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.statusCode === 401){
                    console.log(">> Session Timeout", items);
                    localStorage.removeItem("token");
                    localStorage.removeItem("userData");
                    window.location.href = ConstantsList.LOGIN;
                    alert(items.message || "Session expired. Please login again.");
                    return;
                }else{
                    return items;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

async function downloadReport(param) {
    const request = {
        ...param,
        download: true,
        timeZone: userTimezone,
        userDateTime: moment.tz(userTimezone).toDate(),
    };
    const api_url = config.BASE_URL + `api/${param.url}`;
    const response = await fetch(api_url, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": 'Bearer ' + userData.token,
        },
        body: JSON.stringify(request),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Download failed (${response.status})`);
    }

    const disposition = response.headers.get('content-disposition') || '';
    const filenameMatch = disposition.match(/filename="?([^";]+)"?/i);
    const filename = filenameMatch ? filenameMatch[1] : 'SummaryReport.xlsx';
    saveAs(await response.blob(), filename);
    return true;
}

// Common POST Method for Upload
async function callPOSTUpload(api_url,param) {
    // console.log(">>callPOSTUpload param ", param);
    return await fetch(api_url,{
                method:'POST',
                headers:{
                    // 'Content-Type': 'multipart/form-data',
                    "Authorization": 'Bearer '+ userData.token,
                },
                body:param
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                // console.log(">> Service Login Data",items);
                if(items.responseCode !== 401){
                    // console.log(">> POST Service Call",items);
                    return items;
                }else{
                    console.log(">> Session Timeout",items);
                    localStorage.setItem('token',''); 
                    localStorage.setItem('userData','');
                    window.location = ConstantsList.LOGIN;
                }     
               
            }).catch(error => {
                handleError(error);
            });
}

/* ---------------------------- Common Start --------------------------------*/

//POST - getMenuOnUserRole
async function getMenuOnUserRole(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/getMenu";
    return callGET(api_url, param);
}

//POST - Constant Variable
async function getConstantVariable(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/getConstantVariable";
    return callGET(api_url, param);
}

async function getTransactionListData(param) {
    let api_url= config.BASE_URL + `api/${param.method}`;
    return callPOST(api_url, param);
}

async function getMasterListData(param) {
    let api_url= config.BASE_URL + `api/${param.list}`;
    return callPOST(api_url, param);
}

async function searchMasterListData(param) {
    let api_url= config.BASE_URL + `api/${param.SEARCH}`;
    return callPOST(api_url, param);
}

async function getMasterListDataById(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

async function getMachineJobcardDataByDeptId(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

async function getActiveMasterListDataById(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

async function addMasterData(param) {
    let api_url= config.BASE_URL + `api/${param.method}`;
    return callPOST(api_url, param);
}

async function updateMasterData(param) {
    let api_url= config.BASE_URL + `api/${param.method}`;
    return callPOST(api_url, param);
}

async function deleteMasterData(param) {
    let api_url= config.BASE_URL + `api/${param.method}`;
    return callPOST(api_url, param);
}

async function acknowlegedJobcard(param) {
    let api_url= config.BASE_URL + `api/acknowlegedJobcard`;
    return callPOST(api_url, param);
}

async function acknowlegedSelectedJobcards(param) {
    let api_url= config.BASE_URL + `api/acknowlegedAllJobcards`;
    return callPOST(api_url, param);
}

async function getdeptAckStatusReports(param) {
    let api_url= config.BASE_URL + `api/getdeptAckStatusReports`;
    return callPOST(api_url, param);
}

async function completeJobcard(param) {
    let api_url= config.BASE_URL + `api/completeJobcard`;
    return callPOST(api_url, param);
}

async function startStopJobcard(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

async function getDepartmentsList(param) {
    let api_url= config.BASE_URL + `api/getDepartmentsList`;
    return callPOST(api_url, param);
}
async function getAllJobcards(param) {
    let api_url= config.BASE_URL + `api/getAllJobcards`;
    return callPOST(api_url, param);
}
async function getJobcardsByYear(param) {
    let api_url= config.BASE_URL + `api/getJobcardsByYear`;
    return callPOST(api_url, param);
}
async function departmentAnalyticsReports(param) {
    let api_url= config.BASE_URL + `api/departmentAnalyticsReports`;
    return callPOST(api_url, param);
}
async function machineAnalyticsReports(param) {
    let api_url= config.BASE_URL + `api/machineAnalyticsReports`;
    return callPOST(api_url, param);
}
async function userDurationsReport(param) {
    let api_url= config.BASE_URL + `api/userDurationsReport`;
    return callPOST(api_url, param);
}

async function getOverview(param) {
    let api_url= config.BASE_URL + `api/getOverview`;
    return callPOST(api_url, param);
}

async function getMonthOverview(param) {
    let api_url= config.BASE_URL + `api/getMonthOverview`;
    return callPOST(api_url, param);
}

async function oeeDashboardReport(param) {
    let api_url= config.BASE_URL + `api/oeeDashboardReport`;
    return callPOST(api_url, param);
}
async function updateReworkJobcard(param) {
    let api_url= config.BASE_URL + `api/updateReworkJobcardById`;
    return callPOST(api_url, param);
}

//POST - LOGIN USER
async function login(param) {
    let api_url= config.BASE_URL + 'api/login';
    return fetch(api_url,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(param)
            }).then(response => {
                if (!response.ok) {
                    handleResponseError(response);
                }
                return response.json();
            }).then(items => {
                if(items.status === 200){
                    console.log(">> Service Login Data",items);
                    localStorage.setItem('token',items.token); 
                    localStorage.setItem('userData',JSON.stringify(items)); 
                    // sessionStorage.setItem('token',items.token); 
                    return items;
                }else{
                    return items;
                }
              
            }).catch(error => {
                handleError(error);
            });
}

//POST - LOGOUT USER
async function logout(param) {
    let api_url= config.BASE_URL + 'api/logout';
    return fetch(api_url,{
        method:'POST',
        headers:{
            "Content-Type":"application/json",
            "Accept":"application/json",
            "Authentication": 'Bearer '+ userData.token
        },
        body:JSON.stringify(param)
    }).then(response => {
        if (!response.ok) {
            handleResponseError(response);
        }
        return response.json();
    }).then(items => {
        console.log(">> Service Logout",items);
        if(items.statusCode === 401){
            console.log(">> Session Timeout", items);
            localStorage.removeItem("token");
            localStorage.removeItem("userData");
            window.location.href = ConstantsList.LOGIN;
            // alert(items.message || "Session expired. Please login again.");
            return;
        }else{
            return items;
        }  
    }).catch(error => {
        handleError(error);
    });
}

//POST - USER PROFILE IMAGE UPLOAD 
async function uploadImg(param) {
    let api_url= config.BASE_URL + 'api/uploadImg';
    return callPOSTUpload(api_url,param);
}
// --------------------------- Transaction ------------------------------

async function addTransactionData(param) {
    let api_url= config.BASE_URL + `api/${param.method}`;
    return callPOST(api_url, param);
}

async function updateTransactionData(param) {
    let api_url= config.BASE_URL + `api/${param.method}`;
    return callPOST(api_url, param);
}

async function getTransactionListDataById(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}
async function deleteTransactionListDataById(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

async function getAckRecordsBasedOnJobcard(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

/* ---------------------------- Common End --------------------------------*/


/* ---------------------------- Application Start --------------------------------*/

//POST - REGISTER USER
async function registerUser(param) {
    let api_url= config.BASE_URL + 'api/register';
    return callPOST(api_url,param);
}

//POST - userUpdate Commmon
async function userUpdate(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/userUpdate";
    return callPOST(api_url, param);
}

//POST - get department list by size code Commmon
async function getProcessMasterListDataById(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/getProcessMasterListDataById";
    return callPOST(api_url, param);
}

//POST - get chemical details By Dept
async function getChemicalDetailsByDept(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/getChemicalDetailsByDept";
    return callPOST(api_url, param);
}

//POST - FETCH Chemical Batch Details to show in Start, Ack and Confirm window
async function getChemicalBatchByDept(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/getChemicalBatchByDept";
    return callPOST(api_url, param);
}

async function updateChemicalByDept(param) { // This method calling from Redux
    let api_url= config.BASE_URL + "api/updateChemicalByDept";
    return callPOST(api_url, param);
}


async function generateQCReport(param) {
    let api_url= config.BASE_URL + "api/generateQCReport";
    return callPOST(api_url, param);
}

async function fetchQCReport(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

async function updateJobcardCompleteRemarks(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

async function updateMaterialTrace(param) {
    let api_url= config.BASE_URL + `api/${param.url}`;
    return callPOST(api_url, param);
}

/* ---------------------------- Application End --------------------------------*/

async function allCommonServices(param, methodName) {
    let api_url= config.BASE_URL + `api/${methodName}`;
    return callPOST(api_url, param);
}

async function getConsumptionReasons(param) {
    let api_url= config.BASE_URL + `api/getConsumptionReasons`;
    return callPOST(api_url, param);
}

async function saveConsumptionQty(param) {
    let api_url= config.BASE_URL + `api/saveConsumptionQty`;
    return callPOST(api_url, param);
}

async function getConsumptionEnteredData(param) {
    let api_url= config.BASE_URL + `api/getConsumptionEnteredData`;
    return callPOST(api_url, param);
}

async function deleteConsumptionEnteredData(param) {
    let api_url= config.BASE_URL + `api/deleteConsumptionEnteredData`;
    return callPOST(api_url, param);
}

async function getChemicalBatchViewJobcards(param) {
    let api_url= config.BASE_URL + `api/getChemicalBatchViewJobcards`;
    return callPOST(api_url, param);
}

const func = {
    downloadReport,
    getChemicalBatchViewJobcards,
    allCommonServices,
    login,
    logout,
    registerUser,
    userUpdate,
    uploadImg,
    handleResponseError,
    handleError,
    callGET,
    callPOST,
    callPOSTUpload,

    getConsumptionEnteredData,
    deleteConsumptionEnteredData,
    saveConsumptionQty,
    getConfig,
    getMenuOnUserRole,
    getLoginUserData,
    getConstantVariable,
    getMasterListData,
    addMasterData,
    deleteMasterData,
    updateMasterData,
    getMasterListDataById,
    getMachineJobcardDataByDeptId,
    getActiveMasterListDataById,
    getTransactionListData,
    getTransactionListDataById,
    deleteTransactionListDataById,
    getAckRecordsBasedOnJobcard,
    addTransactionData,
    updateTransactionData,
    searchMasterListData,
    acknowlegedJobcard,
    startStopJobcard,
    getDepartmentsList,
    getJobcardsByYear,
    getAllJobcards,
    departmentAnalyticsReports,
    machineAnalyticsReports,
    userDurationsReport,
    getOverview,
    oeeDashboardReport,
    completeJobcard,
    acknowlegedSelectedJobcards,
    getdeptAckStatusReports,
    updateReworkJobcard,
    getProcessMasterListDataById,
    getChemicalDetailsByDept,
    updateChemicalByDept,
    getChemicalBatchByDept,
    generateQCReport,
    fetchQCReport,
    updateJobcardCompleteRemarks,
    updateMaterialTrace,
    getMonthOverview,
    getConsumptionReasons
    // searchTransactionListByParam,
    
};

export default func;
